import {
  BMElevationType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { differenceInDays } from "date-fns";
import { Image, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useLocalizedDateFormat } from "../../../../core";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import { HotelData } from "./MobileHomeRecentSearch";

type Props = {
  data: HotelData;
};

export default function RecentSearchHotelCard(props: Props) {
  const {
    data: { checkInDate, checkOutDate, geoName, hotelImageUri },
  } = props;

  const { CorporatePostLogin: cr } = useMobileContentResource();
  const { format } = useLocalizedDateFormat();
  const { BMElevation } = useBMTheme();
  const styles = createStyles(BMElevation);

  return (
    <BMView style={styles.container} row align="center">
      <Image style={styles.image} source={{ uri: hotelImageUri ?? "" }} />
      <BMView style={styles.content} flex spacing="xs">
        <BMText>{geoName}</BMText>
        <BMText variant="uiSmallLi" ink="BMStyleTextInkSecondary">
          {format(checkInDate, "SHORT_MONTH")} ·{" "}
          {formatMessage(cr.nightUnit, {
            num: differenceInDays(checkOutDate, checkInDate),
          })}
        </BMText>
      </BMView>
    </BMView>
  );
}

function createStyles(BMElevation: BMElevationType) {
  return StyleSheet.create({
    container: {
      paddingRight: BMPrimitives.BMSize.md,
      borderRadius: BMPrimitives.BMRadius.md,
      ...BMElevation.elevation2,
      width: 280,
      overflow: "hidden",
    },
    image: {
      width: 50,
      height: 56,
    },
    content: {
      padding: BMPrimitives.BMSize.md,
    },
  });
}
